export const formatPrice = (price) => {
    if (price === null || price === undefined) {
        return null;
    }

    const options = {
        style: 'currency',
        currency: window.config.currency.code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }

    return new Intl.NumberFormat(window.config.language.locale, options).format(Number(price))
}
